import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "fixed z-[40] top-0 right-0 left-0 bottom-0 flex items-center justify-center",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "bg-white rounded-lg shadow-xl transform transition-all sm:max-w-lg sm:w-full w-full h-full mt-16 flex flex-col" }
const _hoisted_3 = { class: "px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_4 = {
  class: "flex justify-between items-center leading-6 font-medium text-grey",
  id: "modal-title"
}
const _hoisted_5 = { class: "overflow-y-scroll flex-grow px-4 mb-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-up" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["fixed top-0 right-0 left-0 bottom-0 transition-opacity", { 'bg-gray-500 bg-opacity-75': _ctx.modelValue }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
        }, null, 2),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-blue text-sm opacity-0" }, "Закрыть", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-lg text-center" }, "Список банков", -1)),
              _createElementVNode("span", {
                class: "text-blue text-sm font-normal",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, "Закрыть")
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mt-2" }, [
              _createElementVNode("p", { class: "text-sm text-gray-500" }, " Воспользуйтесь поиском или выберите из списка ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "body")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.modelValue]
      ])
    ]),
    _: 3
  }))
}